<!-- Percentage: "+4,2%" in gain/loss colour (sign=false: no sign or colour for positive values). -->
<script lang="ts">
  import { pctText, signCls } from "../lib/format";
  let { v, d = 1, sign = true }: { v: number | null | undefined; d?: number; sign?: boolean } = $props();
</script>

{#if v === null || v === undefined || isNaN(v) || !isFinite(v)}–{:else}<span class={sign ? signCls(v) : ""}>{pctText(v, d, sign)}</span>{/if}
